"use client";

import { Button, OptimizedImage } from "@/components";
import { getImageURL, sanitizeHTML } from "@/lib";

export const HomePageBanner = ({ data = {}, slug = "home_page_banner" }) => {
    const { cta = {}, description = "", title = "", bg_image } = data;

    return (
        <>
            <section
                className="home__banner"
                id={slug}
            >
                {bg_image?.src && (
                    <OptimizedImage
                        src={getImageURL(bg_image.src)}
                        alt={bg_image.alt || bg_image.title || "Home Page Banner"}
                        fill
                        priority
                        loading="eager"
                        fetchPriority="high"
                        sizes="100vw"
                        style={{
                            objectFit: "cover",
                            objectPosition: "50% 50%",
                            zIndex: -2,
                        }}
                    />
                )}
                <div className="custom-container">
                    <div className="row ">
                        <div className="col-12 col-md-8 col-lg-6">
                            <div className="banner__area">
                                <div className="banner__content">
                                    <h1
                                        className="h1 fs-72 fw-300"
                                    dangerouslySetInnerHTML={{
                                        __html: sanitizeHTML(title),
                                    }}
                                    />

                                    <div className="content__wrap fs-20">
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: sanitizeHTML(description),
                                            }}
                                        />
                                    </div>
                                    {cta?.title && (
                                        <Button
                                            label={cta.title}
                                            href={cta.url}
                                            openNewTab={
                                                cta.open_new_tab === "yes"
                                            }
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* </div> */}
            </section>
        </>
    );
};
